module.exports = __webpack_public_path__ + "img/dualbit.c30d5002.png";